import axios from 'axios'
import { API_ENDPOINT } from '../../../../config'
import {isValid} from '../common.service'
import {LoadLocations} from '../../../../data/datasource/location.datasource'

const getDefaultState = () => {
    return {
        loading: false,
        loadingLocations: false,
        saving: false,
        name: "",
        phone: "",
        smsSender: "",
        address: "",
        city: "",
        locationId: "",
        locations: [],
        errors: {},
        flag: {
            type: "",
            text: ""
        }
    }
}

const loadSalePoint = instance => {
    instance.setState({ ...instance.state, loading: true })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/services/internet/salepoint",
        headers: {
            "Authorization": instance.props.auth.authorization
        },
        data: {
            id: instance.props.match.params.id
        }
    }).then(response => handleLoadSalePointResponse(instance, response))
        .catch(error => alert(error))
}

const handleLoadSalePointResponse = (instance, response) => {
    switch (response.data.status) {
        case 200:
            instance.setState({
                ...instance.state,
                loading: false,
                name: response.data.data.salePoint.name,
                phone: response.data.data.salePoint.phone,
                smsSender: response.data.data.salePoint.smsSender,
                address: response.data.data.salePoint.address,
                city: response.data.data.salePoint.city,
                locationId: response.data.data.salePoint.location.id
            })
            break;
        case 403:
            instance.props.history.push('/auth/login')
            break;
        default:
            alert(response.data.message)
    }
}

const save = (instance) => {
    instance.setState({
        ...instance.state,
        saving: true
    })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/services/internet/salepoint/update",
        headers: {
            "Authorization": instance.props.auth.authorization
        },
        data: {
            id: instance.props.match.params.id,
            name: instance.state.name,
            locationId: instance.state.locationId,
            phone: instance.state.phone,
            address: instance.state.address,
            city: instance.state.city,
            smsSender: instance.state.smsSender
        }
    }).then(response => handleSaveResponse(instance, response))
        .catch(error => {
            instance.setState({
                ...instance.state,
                saving: false
            })
            alert(error)
        })
}

const handleSaveResponse = (instance, response) => {
    switch (response.data.status) {
        case 200:
            instance.setState({
                saving: false,
                flag: {
                    type: "success",
                    text: "Updated successfully"
                }
            })
            break
        default:
            instance.setState({
                ...instance.state,
                saving: false,
                flag: {
                    type: "error",
                    text: response.data.message
                }
            })
            alert(response.data.message)
    }
}

const Service = instance => {
    return {
        getDefaultState: () => getDefaultState(),
        isValid: () => isValid(instance),
        loadSalePoint: () => loadSalePoint(instance),
        loadLocations: () => LoadLocations(instance),
        save: () => save(instance)
    }
}

export default Service